import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import MediaSection from "./components/MediaSection";
import AppSection from "./components/AppSection";
import UpdatesSection from "./components/UpdatesSection";
import RankingSection from "./components/RankingSection";
import FeaturesSection from "./components/FeaturesSection";
import CarouselSection from "./components/CarouselSection";
import CardsSection from "./components/CardsSection";
import CommentsSection from "./components/CommentsSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import IndexSection from "./components/IndexSection";
import TopicsSection from "./components/TopicsSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <AppSection />
        <UpdatesSection />
        <RankingSection />
        <FeaturesSection />
        <CarouselSection />
        <CardsSection />
        <CommentsSection />
        <AboutSection />
        <FaqSection />
        <ContactSection />
        <IndexSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}